import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LookUpInterFace } from 'src/app/_models/common/lookUp.interface';
import { LookupItems } from 'src/app/_models';

@Injectable({
  providedIn: 'root'
})
export class LookUpService {
  private url: string;
  private apiUrl: string;
  constructor(public http: HttpClient) {
    this.url = `${environment.apiUrl}lookups`;
    this.apiUrl = environment.apiUrl;
  }

  public getBloodGroupLookUp(): Observable<any> {
    return this.http.get(`${this.url}/GetBloodGroup`);
  }

  getPackeges() {
    return this.http.get(`${this.url}/GetPackeges`);
  }
  getCountries() {
    return this.http.get(`${this.url}/GetCountries`);
  }

  getCities(id: number) {
    return this.http.get(`${this.url}/GetCities/${id}`);
  }
  GetAllGradeByTypeId(id: number) {
    return this.http.get(`${this.apiUrl}/AssessmentAndGrades/GetAllGradeByTypeId/${id}`);
  }

  getEducationalPrograms(selectedAcademicProgramId: number) {
    return this.http.get(`${this.url}/GetEducationalPrograms/${selectedAcademicProgramId}`);

    // if (selectedAcademicProgramId === 1)
    //     return Observable.of([
    //         {
    //             id: 1,
    //             name: "الخاص",
    //             nameLatin: "Private",
    //         },
    //         {
    //             id: 1,
    //             name: "العام",
    //             nameLatin: "Public",
    //         }
    //     ]);

    // return Observable.of([
    //     {
    //         id: 1,
    //         name: "الأمريكي",
    //         nameLatin: "American",
    //         subPrograms: [
    //             { name: "SAT", nameLatin: "SAT" },
    //             { name: "AP", nameLatin: "AP" },
    //             { name: "HSD", nameLatin: "HSD" },
    //             { name: "SATII", nameLatin: "SATII" }
    //         ]
    //     },
    //     {
    //         id: 2,
    //         name: "البريطاني",
    //         nameLatin: "British",
    //         subPrograms: [
    //             { name: "IGCSE", nameLatin: "IGCSE" },
    //             { name: "CP", nameLatin: "CP" },
    //             { name: "CS", nameLatin: "CS" }
    //         ]
    //     },
    //     {
    //         id: 3,
    //         name: "الكندي",
    //         nameLatin: "Canadian",
    //         subPrograms: [
    //             { name: "ALBERTA", nameLatin: "ALBERTA" }
    //         ]
    //     },
    //     {
    //         id: 4,
    //         name: "البكالوريا الدولية",
    //         nameLatin: "International Baccalaureate ",
    //         subPrograms: [
    //             { name: "PYP", nameLatin: "PYP" },
    //             { name: "MYP", nameLatin: "MYP" },
    //             { name: "DP", nameLatin: "DP" },
    //         ]
    //     },
    //     {
    //         id: 5,
    //         name: "الهندي",
    //         nameLatin: "Indian  ",
    //         subPrograms: [
    //             { name: "CBSC", nameLatin: "CBSC" },
    //             { name: "SSLC", nameLatin: "SSLC" },
    //             { name: "CBCE", nameLatin: "CBCE" },
    //             { name: "ICSE", nameLatin: "ICSE" }
    //         ]
    //     }
    // ]);
  }

  getGradeScaleTypes() {
    return this.http.get(`${this.url}/GetGradeScaleType`);
  }

  getAcademicPrograms() {
    return this.http.get(`${this.url}/GetAcademicPrograms`);
  }

  getUserstatuses() {
    return this.http.get(`${this.url}/GetStatuses`);
  }

  getAcadimicYears() {
    return this.http.get(`${this.url}/GetAcademicYear`);
  }

  getNationalities() {
    return this.http.get(`${this.url}/GetNationalities`);
  }

  getUserTypes() {
    return this.http.get(`${this.url}/GetUserType`);
  }
  // getSchools() {
  //     return this.http.get(`${this.apiUrl}/School/GetSchoolsBasicInformation`);
  // }
  getSchoolAndEducation(selectedAcademicProgramId: number, schoolId: number, companyId: number) {
    return forkJoin(
      this.http.get(`${this.apiUrl}/School/GetSchoolsBasicInformation/${companyId}`),
      this.http.get(`${this.url}/GetEducationalProgramsBySchool/${selectedAcademicProgramId}/${schoolId}`)
    );
  }

  getReligions() {
    return this.http.get(`${this.url}/GetReligions`);
  }

  getIdentityTypes() {
    return this.http.get(`${this.url}/GetIdentityTypes`);
  }

  getLanguages() {
    return this.http.get(`${this.url}/GetLanguages`);
  }

  getAuditingRoles() {
    return this.http.get(`${this.url}/GetAuditingRoles`);
  }

  getSchoolGender() {
    return this.http.get(`${this.url}/GetSchoolGender`);
  }

  getPlanClassifications(): Observable<LookUpInterFace[]> {
    return this.http.get<LookUpInterFace[]>(`${this.url}/GetPlanClassifications`);
  }

  getEducationalProgramBySchool(academicProgramId: number, schoolId: number) {
    return this.http.get<LookUpInterFace[]>(`${this.url}/GetEducationalProgramsBySchool/${academicProgramId}/${schoolId}`);
  }

  getEducationalProgramBySchoolId( schoolId: number) {
     return this.http.get<LookUpInterFace[]>(`${this.url}/GetEducationalProgramsBySchool/${schoolId}`);
  }

  getScaleMethods() {
    return this.http.get(`${this.url}/GetScaleMethods`);
  }

  getScaleGroups() {
    return this.http.get(`${this.url}/GetScaleGroups`);
  }

  getAssessmentScaleStatus() {
    return this.http.get(`${this.url}/GetScaleStatuses`);
  }

  getQuestionsOrder(): Observable<LookUpInterFace[]> {
    return this.http.get<LookUpInterFace[]>(`${this.url}/GetQuestionsOrder`);
  }
  AddLookupItem(lookupItems: LookupItems) {
    return this.http.post(`${this.apiUrl}LookupItem/AddLookupItem`, lookupItems);
  }
  EditLookupItem(lookupItems: LookupItems) {
    return this.http.put(`${this.apiUrl}LookupItem/EditLookupItem`, lookupItems);
  }
  DeleteLookupItem(id: number) {
    return this.http.delete(`${this.apiUrl}LookupItem/DeleteLookupItem/${id}`);
  }
  GetLookups(lookupCategory: number, parentId: number = null) {
    if (parentId === null) return this.http.get(`${this.apiUrl}LookupItem/GetLookups/${lookupCategory}`);
    else return this.http.get(`${this.apiUrl}LookupItem/GetLookups/${lookupCategory}/${parentId}`);
  }

  getAssignmentDisplayResults(): Observable<LookUpInterFace[]> {
    return this.http.get<LookUpInterFace[]>(`${this.url}/GetAssignmentDisplayResults`);
  }
}
